import React from "react";
import styles from "./errorBox/ErrorBox.module.scss";

const ErrorBox = ({ type = 'default', title, children, errorCode, width = '120px', top, left, handleCloseToast }) => {

    return (
        <div className={`${styles.ErrorBox} ${type === 'toast' && styles.toast}`} style={{width, top, left}}>
            <div className={'d-flex align-items-center justify-content-between'}>
                <div className={styles.title}>
                    { title }
                </div>
                {
                    type === 'toast' &&
                        <div onClick={handleCloseToast} className={'d-flex align-items-center'}>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <line x1="12.666" y1="4.39399" x2="4.39334" y2="12.6667" stroke="#C2C7ED" stroke-width="1.5" stroke-linecap="round"/>
                                <path d="M3.95508 3.95554L12.6284 12.6289" stroke="#C2C7ED" stroke-width="1.5" stroke-linecap="round"/>
                            </svg>
                        </div>
                }
            </div>
            <div className={styles.description}>
                { children }
            </div>
            <div className={styles.errorCode}>
                Error Code: { errorCode }
            </div>
        </div>
    )
}

export default ErrorBox;